import * as React from 'react';
import { memo } from 'react';

export type ReactInnerHTML = {
	__html: string;
};

export type RichProps = {
	contents?: string;
	modifier?: string;
};

export const Rich = ({ contents, modifier }: RichProps) => {
	return contents ? (
		<div
			className={`m-rich${modifier ? ` m-rich--${modifier}` : ''}`}
			dangerouslySetInnerHTML={{ __html: contents }}
		/>
	) : null;
};

export default memo(Rich);
